
export function pathToRoot() {
	return `/`;
}

export function pathToForumsIndex() {
	return process.env.config.section.home === false && process.env.config.IndexRoute === 'index' ? `/` : `/forums`;
}

export function pathToForum(forumId) {
	return `/forums/${forumId}`;
}

export function pathToThread(threadId) {
	return `/topics/${threadId}`;
}

export function pathToSearch(searchid=0) {
	return `/search/${searchid}`;
}

export function pathToActiveTopics() {
	return `/latest`;
}

export function pathToNewPosts() {
	return `/updated`;
}

export function pathToParticipated() {
	return `/participated`;
}

export function pathToSubscribed() {
	return `/following`;
}

export function pathToReleaseNotes() {
	return `/release`;
}

export function pathToMessages() {
	return `/pms`;
}

export function pathToMessagesFolder( folder ) {
	return `/pms/${folder}`;
}

export function pathToMessagesPM( message ) {
	return `/pm/${message}`;
}

export function pathToPost( postId ) {
	return `/topics/0?postid=${postId}`;
}

export function pathToUserProfile( userId ) {
	return `/userprofile/${ userId }`;
}

export function pathToOnline() {
	return `/online`;
}

export function pathToSettings() {
	return `/settings`;
}

/** Get info about the path:
 * path[ 0 ] => pathname
 * path[ 1 ] => section unless we are at /
 * path[ 2 ] => id
 *
 * @param path
 * @returns {Array|{index: number, input: string}}
 */
export function parsePath( path ) {
	let re = /(?:([#/]*[?&]?)([^\/&?#]+))?/ig,
		parsedPath = [],
		m;
	while( ( m = re.exec( path ) ) !== null ) {
		if (m.index === re.lastIndex) {
			re.lastIndex++;
		}
		if( /[?&#]/.test( m[2] ) === false ) {
			parsedPath.push( m[2] );
		}
	}
	if( parsedPath.length ) {
		parsedPath.unshift( path );
	}
	return parsedPath;
}



// WEBPACK FOOTER //
// ./src/utils/nav/NavHelpers.js